export default (params) => ({
  trigger: {
    name: 'image_gallery.select_promo_icon',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_content',
      params: {
        sub_feature: 'promo_icon',
      },
    },
  },
});
